import React, { Component } from 'react'
import PureComponent from '../../pure'

import  sAction  from "sAction";

import confProd from "./productLineConfig";
import Button from "../../formElements/Button";


class QGroupTotal extends PureComponent{

    addProdLine(itway){
        //this.setState({show:true});
        sAction.updateDetailCustom("addProdLine", {way:itway+"/lines"})
    }

    render(){
    var data = this.props.data;
    const way = this.props.way;
    const readonly = this.props.readonly;

    const sums = sAction.calcSums(way, {type : "group", data : data, cenotvorba: this.props.cenotvorba});
    const conf = confProd.sums;
    const ind = this.props.ind;

    const self = this;

    var renderComp = [];
    if(!readonly){
        renderComp.push(<Button 
            className="acmAddRowBtn hoverGreen"
            key={"addBtn"}
            variant="text" 
            onClick={() => self.addProdLine(way)}>
            <div className="buttonIcon icon-addRowIcon" />
        {sAction.translate("LBL_ADD_ROW", "Quotes")}
        </Button>);
        renderComp.push(
            <div key="firstFiller" style={{width:"40px"}} />
        );
    }
    else{
        renderComp.push(
            <div key="firstFiller" style={{width:"14px"}} />
        );
    }

    
    
    renderComp.push(
        <div key="secondFiller" style={{width:"33%"}} />
    );

    conf.forEach( function(field){ 
        if(!field.visible){
            return;
        }
        if(field.type == "price"){
            
                     

            renderComp.push(
                <div style={{width:field.width}} className="amountsContainer" key={ind+"_"+field.name}>
                    <div>{sAction.translate(field.lbl, field.lblMod)}</div>
                    <div>{sAction.formatNumber(sums[field.name])}</div>
                </div>
            );

            if(field.name == "total_list_price"){
                renderComp.push(
                    <div key="fourthFiller" style={{width:"14%"}} />
                );          
            }   

            if(field.name == "total_cost_price"){
                renderComp.push(
                    <div key="thirdFiller" style={{width:"9%"}} />
                ); 
            }
        }
        else if(field.type == "addBtn"){
            
        }
    });
    

    return <div className="QTotalContainerFirstRow QTotalContainerRow">
        {renderComp}
    </div>;
    }
}

export default QGroupTotal